import React, { useState, useEffect,useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import TableAllData from "components/Content/CustomTable/TableAllData";

import { Box } from "@mui/material";
import AximDropdown from "components/Dropdown/AximDropdown";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Utils } from "common/Utils";

function Hourbank () {
  const { companyId, userInfo } = useContext(PrivateRoutesContext);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [fetchedData, setHourBanks] = useState([]);
  const [years, setYears] = useState([]);

  useEffect(() => {
    handleChangeCompany()
  }, [companyId]);

  const canDownload = useMemo(() => {
    return !Utils.isBroker(userInfo);
  },[userInfo]);

  useEffect(() => {
    if (years && years.length > 0) {
      setSelectedYear(years[0]);
    }
  },[years])

  useEffect(() => {
    if (companyId && selectedYear) {
      setIsLoading(true);

      apiGet(apiUrls.getHourbankDetails(companyId, selectedYear)).then(
        (response) => {
          setHourBanks(response.data);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  },[companyId, selectedYear])

  const handleChangeCompany = () => {
    apiGet(apiUrls.getCompanyDropdowns(companyId)).then(
      (response) => {
        console.log(response.data);
        if (response.data && response.data.years && response.data.years.length > 0) {
        setYears(response.data.years.sort().reverse());
        }
        else {
          setYears([]);
        }
      })
      .catch((e) => {
        
      });
  }

  const columns = [
    {
      Header: "Date",
      accessor: (cell) => Utils.formatDate(cell.periodName), // format date
      Cell: ({row}) => (
        <Box>
          {Utils.formatDate(row.original.periodName)}
        </Box>
      ),
      sortType: "dateSort",
    },
    {
      Header: "Beginning Balance",
      accessor: (cell) => 
        <Box className="text-end">
          <CurrencyFormatter value={cell.beginningBalance} /> 
        </Box>,
      className: 'text-end',
    },
    {
      Header: "Contribution Amount",
      accessor: (cell) => 
        <Box className="text-end">
          <CurrencyFormatter value={cell.amount} /> 
        </Box>,
      className: 'text-end',
    },
    {
      Header: "Retro Amount This Year",
      accessor: (cell) => 
        <Box className="text-end">
          <CurrencyFormatter value={cell.retroAmountInYear} /> 
        </Box>,
      className: 'text-end',
    },
    {
      Header: "Retro Amount Prior Year",
      accessor: (cell) => 
        <Box className="text-end">
          <CurrencyFormatter value={cell.retroAmountPriorYear} /> 
        </Box>,
      className: 'text-end',
    },
    {
      Header: "Total Retro Amount",
      accessor: (cell) => 
        <Box className="text-end">
          <CurrencyFormatter value={cell.retroAmount} /> 
        </Box>,
      className: 'text-end',
    },
    {
      Header: "Ending Balance",
      accessor: (cell) => 
        <Box className="text-end">
          <CurrencyFormatter value={cell.endingBalance} /> 
        </Box>,
      className: 'text-end',
    },
    {
      Header: "Hourbank Type",
      accessor: "hourbankTypeCode",
    },
  ];


  return (
    <div className={TableStyle.tableWrapper}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
        <div>
          <AximDropdown
            id="select-year"
            label="Select Year"
            handleChange={(e) => setSelectedYear(e.target.value)}
            value={selectedYear}
            pairs={years.map(item => ({ value: item }))} />
        </div>
        {/* HOURBANK TYPE DROPDOWN */}
        {/* <div>
              <AximDropdown
                id="select-hourbank-type"
                label="Select Hourbank Type"
                handleChange={handleHourbankType}
                value={hourbankType}
                pairs={fetchedData.map(item => ({ value: item, text: item.hourbankTypeCode }))} />
            </div> */}
      </div>
      <TableAllData
        columns={columns}
        data={fetchedData ? fetchedData : "No Data"}
        isLoading={isLoading}
        download={canDownload ? { prefix: "Hourbank", table: "Hourbank" } : null}
      />
    </div>
  );
}

export default Hourbank;
